"use strict";
angular.module('televisionModule', [
	'televisionRouterModule',
	'televisionLeftModule',
	'televisionToBeCompiledModule',
	'televisionPendingModule',
	'televisionSignedModule',
	'televisionServiceModule',
	'televisionPreviewRouterModule',
	])